import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetWarehouseResponse, GetWarehousesResponse} from '../types';

const getWarehouseResponseMock: GetWarehouseResponse = {
  id: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
  warehouseNumber: 'WH01',
  name: 'Hyundai CZ',
  defaultSupplierId: 'a024ebfe-b790-47b2-ac85-da86ac458869',
  defaultManufacturerId: '04911c52-e6fc-11ee-bd3d-0242ac120002',
  warehousePricing: 'AVG',
  branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  companyBillingInfoId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
  allowServiceOrderIssue: true,
  allowedOrderVariants: [
    '61d8cd9c-1da3-4eba-85cb-c39514c14e07',
    '746b2976-77fa-4763-afc3-385675815a88',
    'e2964fd3-06d5-45a9-8cfe-eafacd404d27',
    'ddf85276-8d27-42ba-985a-d01caec5d831',
    '6588f228-7d26-4799-98e1-803cf2d2cf7e',
    '44c3bfa6-5cd3-41ab-b42b-4451f8c3aae0',
    '626ca8b8-c2fe-49ca-8016-5d0efb738d15',
    'af30bfa5-773c-4961-b1ed-9b9eabcd4d18',
    '2fa5bf29-1c31-4b42-91c3-90d23e0533ad',
    '57b2baa4-0919-4bfa-acef-15eab81cd13d',
    '9634c852-882a-4681-b783-b5d851ecdfd7',
    'fdf29215-9c02-4c6f-88cd-0a463434e368',
    '6e6a07c3-cc36-4c1b-b14b-abf9e45b9216',
  ],
  stockNumberPrefix: 'HCZ01-',
  receiveNoteSeriesId: '5568682c-62de-4d4f-80cc-9fb38d710815',
  receiveNoteTemplateId: 'cd30cc52-da18-43e4-b0a6-6f24fffe78a1',
  creditNoteSeriesId: '427f583f-b951-4132-b7f1-a06ec1e86585',
  creditNoteTemplateId: '6be38b90-a31a-4eaa-9fa9-aca1d5f3c906',
  issueNoteSeriesId: '727d0e9d-edeb-44e8-b3d3-eca3dae1781c',
  issueNoteTemplateId: 'd5b3b20d-0e7a-417a-811c-9dd371e2c3b2',
  issueNoteCorrectionSeriesId: '468b11a9-93ee-449c-bb2f-2fb7e2d3e98a',
  issueNoteCorrectionTemplateId: '34b02a4b-8192-46fe-b242-0437fb15adfc',
  salesPriceCalculation: 'MARGIN_ON_BASE',
  basePriceSource: 'AVG_PURCHASE',
  salePriceMarginPercent: 20,
  blockPricingSettingOnArticle: false,
  unitSalesPriceWithVat: false,
  isFastTrack: false,
  dummyWarehouse: false,
  workItemGroupId: 'a024ebfe-b790-46fe-b242-0437fb15adfc',
  allSuppliers: false,
  suppliers: [
    {
      id: 'a024ebfe-b790-47b2-ac85-da86ac458869',
    },
  ],
  allowDirectSaleIssue: true,
  allowedDirectSaleVariants: [
    '88f74ea3-e6ce-4db0-8cf2-0104b1332679',
    '57dfc221-0516-46b9-93f2-d845e47b365e',
    '1f298c5a-df09-4abe-ba61-57b7b0f2a66e',
    'e7694c31-23f4-4a0d-a356-e0ca26c873d8',
    'a8ef5382-2b94-4b5f-9699-a59a7d412915',
    '7fe62930-bb7f-4322-8750-92242b57c971',
  ],
  authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
  currency: 'EUR',
  created: '2024-03-28T17:06:02.703Z',
  createdBy: '0b592803-9bef-4840-b0ab-9a2cb6ded726',
  updated: '2024-06-24T15:03:15.667Z',
  updatedBy: '4ce6d202-7684-4939-9d1d-7130c95b9310',
};

const getWarehouseResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/warehouse/*', () => HttpResponse.json(getWarehouseResponseMock))
  );

const getWarehousesResponseMock: GetWarehousesResponse = [
  {
    id: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
    warehouseNumber: 'WH01',
    name: 'Hyundai CZ',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
  },
  {
    id: 'c89ad6a6-4f36-4a22-9662-ea7bd3318a7e',
    warehouseNumber: 'WH02',
    name: 'Hyundai SK',
    authorizationProfileId: '9719fbcb-71a0-4948-9006-6e80a22cfd70',
  },
  {
    id: 'b3da185b-a810-4762-9871-0915d76e6654',
    warehouseNumber: 'test',
    name: 'JS Delete me',
    authorizationProfileId: '55041578-ed1d-11ee-a951-0242ac120002',
  },
  {
    id: 'b1788094-6866-42ef-a5ea-8a0fa96d1994',
    name: 'JS WH 1',
    authorizationProfileId: '4a73a044-a0d9-4482-b3ac-ffd0a2b75acb',
  },
  {
    id: '1d015a9f-e025-4d36-aabb-706b0e96f57c',
    name: 'JS WH 3 (SK)',
    authorizationProfileId: '597601a2-ed1d-11ee-a951-0242ac120002',
  },
  {
    id: '6df2c0eb-bf31-4528-a9d9-d3368b82eaa2',
    name: 'JS WH Hyundai',
    authorizationProfileId: '4e4e045a-ed1d-11ee-a951-0242ac120002',
  },
  {
    id: '02a025e0-2485-4722-a460-5692b713db8b',
    name: 'Mercedes Czech',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
  },
  {
    id: '83de99ab-ed2d-45f2-994c-f3ab9bca130c',
    warehouseNumber: 'XX1',
    name: 'test bp',
    authorizationProfileId: 'babda298-3ff3-49bf-9b12-ab21ed467429',
  },
  {
    id: '8b87d889-c7f0-4bb3-a98d-8598b779299b',
    warehouseNumber: 'XX3',
    name: 'test bp 3',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
  },
];

const getWarehousesResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/warehouses', () => HttpResponse.json(getWarehousesResponseMock))
  );

const postWarehouseInterceptor = (server: SetupServerApi) =>
  server.use(http.post('*/warehouse/v2/warehouse', () => HttpResponse.json()));

const patchWarehouseInterceptor = (server: SetupServerApi) =>
  server.use(http.patch('*/warehouse/v3/warehouse/*', () => HttpResponse.json()));

export const metadaWarehouseApiMock = {
  getWarehouseResponseMock,
  getWarehouseResponseInterceptor,
  getWarehousesResponseMock,
  getWarehousesResponseInterceptor,
  postWarehouseInterceptor,
  patchWarehouseInterceptor,
};
